import { QUICK_COMMERCE_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import {
  IQuickCommercePincodeDetailResponse,
  IQuickCommercePincodeDetailResponseData,
} from "@/api_framework/api_modals/QuickCommerce";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useQuickCommerce } from "../../useQuickCommerce";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useQuickCommercePincodeDetailAPI = () => {
  const [pincodeDetail, setPincodeDetail] = useState<IQuickCommercePincodeDetailResponseData | null>(null);
  const quickCommerce = useQuickCommerce();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (cityId: number) => {
      try {
        const accessToken = localStorage.getItem(quickCommerce.localStorage.ACCESS_TOKEN.key);
        if (!cityId) {
          return;
        }
        await axios
          .get(`${QUICK_COMMERCE_APIS?.PINCODE_DETAIL?.baseURL}${cityId}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IQuickCommercePincodeDetailResponse>) => {
            if (res.data.status === true) {
              console.log(res.data.data);
              setPincodeDetail(res.data.data);
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Error at server while fetching city details.");
          }
          if (axiosError.response?.status === 400) {
            toast.error(axiosError.message);
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, quickCommerce],
  );

  return { pincodeDetail, execute };
};
